<span
    class="inline-flex items-center rounded-lg bg-primary-100 px-3 py-1 text-sm font-semibold text-primary-700"
>
    <span [appTooltip]="'translate_kpi_code' | translate">
        {{ kpiPrefix + '-' + kpi.type.code + '-' + kpi.code }}
    </span>

    <button
        class="ms-2 flex items-center rounded-full p-1 text-primary-600 transition-colors hover:bg-primary-200 hover:text-primary-800"
        [appTooltip]="'translate_copy_to_clipboard' | translate"
        (click)="
            copyToClipboard(kpiPrefix + '-' + kpi.type.code + '-' + kpi.code)
        "
    >
        <em class="fa-light fa-copy"></em>
    </button>
</span>
